import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BannerContentType, BannerService, BannerType } from './banner.service';
import { CommonModule } from '@angular/common';
import { DynamicModule } from 'ng-dynamic-component';
import { IconComponent } from '@design-system/buttons/icon/icon.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    DynamicModule,
    TestIdDirective
  ]
})
export class BannerComponent {
  @Input() bannerName = "";

  @Input() contentType?: BannerContentType;

  @Input() bannerType: BannerType = 'warning';

  @Input() showClose = true;

  @Input() marginBottom = '2rem';
  
  @Input() padding = '0.8rem 1.6rem';

  @Input() centerContent = false;

  constructor(public bannerService: BannerService) {}
}
